// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActivityDetailController from "./activity_detail_controller.js"
application.register("activity-detail", ActivityDetailController)

import HelloController from "./hello_controller.js"
application.register("hello", HelloController)

import NumpadController from "./numpad_controller.js"
application.register("numpad", NumpadController)
